import React, { useMemo } from 'react';

// TODO: check types, its temporary
import DialogDraggable from 'components/mui/Dialog/DialogDraggable';
import DialogTitle from 'components/mui/Dialog/DialogTitle';
import DialogActions from 'components/mui/Dialog/DialogActions';
import DialogContentMui from '@mui/material/DialogContent';
import PaperComponent from 'components/mui/Dialog/PaperDraggable';

// Legacy wrapper. Own props keep real value types below; the index signature
// admits the `...rest` props forwarded to the underlying MUI Dialog (legacy
// callers pass Elements as title and null as callbacks, so those stay loose).
/**
 * @type {React.FC<{
 *   children?: any,
 *   open?: boolean,
 *   title?: any,
 *   okText?: any,
 *   cancelText?: any,
 *   onClose?: (() => void) | null,
 *   onCancel?: (() => void) | null,
 *   onOk?: (() => void) | null,
 *   withActions?: boolean,
 *   withContent?: boolean,
 *   disableBackdropClose?: boolean,
 *   draggable?: boolean,
 *   forFormID?: string,
 *   dividers?: boolean,
 *   withCloseBtn?: boolean,
 *   okBtnProps?: Record<string, any> | null,
 *   cancelBtnProps?: Record<string, any> | null,
 *   closeBtnProps?: Record<string, any>,
 *   [rest: string]: any,
 * }>}
 */
const Dialog = ({
  children,
  open,
  title,
  okText,
  cancelText,
  onClose,
  onCancel,
  onOk,
  withActions = true,
  withContent = true,
  disableBackdropClose = false,
  draggable = true,
  forFormID = undefined,
  dividers = false,
  withCloseBtn = false,
  okBtnProps,
  cancelBtnProps,
  closeBtnProps,
  ...rest
}) => {
  const handleOnClose = (event, reason) => {
    if (disableBackdropClose && reason === 'backdropClick') return;

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const PaperComponentProps = useMemo(() => (draggable ? { PaperComponent } : {}), [draggable]);

  return (
    <DialogDraggable
      fullWidth
      open={open}
      maxWidth="xs"
      scroll="paper"
      onClose={handleOnClose}
      {...PaperComponentProps}
      {...rest}
    >
      <DialogTitle onClose={onClose} draggable={draggable} withCloseBtn={withCloseBtn} closeBtnProps={closeBtnProps}>
        {title}
      </DialogTitle>

      {withContent ? <DialogContentMui dividers={dividers}>{children}</DialogContentMui> : children}

      {withActions && (
        <DialogActions
          onCancel={onCancel || onClose}
          onOk={onOk}
          okText={okText}
          cancelText={cancelText}
          forFormID={forFormID}
          okBtnProps={okBtnProps ?? undefined}
          cancelBtnProps={cancelBtnProps ?? undefined}
        />
      )}
    </DialogDraggable>
  );
};

export default Dialog;
